
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 17h-7.25v-2.5a.5.5 0 00-.5-.5h-7.5a.5.5 0 00-.5.5V19H.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h23a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zM1 20h6.75v3H1zm7.75-.5V15h6.5v8h-6.5zM23 23h-6.75v-5H23z"}}),_c('ellipse',{attrs:{"cx":"12","cy":"7.94","rx":"1.12","ry":"1.14"}}),_c('path',{attrs:{"d":"M7.4 12.5h9.2a.5.5 0 00.5-.45l.9-8.12a.5.5 0 00-.8-.46l-2.45 1.81-2.33-3.55a.52.52 0 00-.84 0L9.25 5.28 6.8 3.47a.5.5 0 00-.8.46l.9 8.13a.5.5 0 00.5.44zm1.69-6.1a.49.49 0 00.38.09.5.5 0 00.33-.22L12 2.91l2.2 3.36a.5.5 0 00.33.22.5.5 0 00.39-.09l1.96-1.45-.73 6.55h-8.3l-.73-6.55z"}})])
          )
        }
      }
    